import {customElement, property} from "lit/decorators.js";
import {FormInputElement} from "./formInputElement";
import {html, type TemplateResult} from "lit";
import Styles from "./formToggleLink.lit.scss";
import {noop} from "../../../common/utils/functions";
import {ClickTracking} from "../../../tracking/clickTracking";
import {resolve} from "../../../container";

@customElement("eop-form-toggle-link")
export class EopFormToggleLink extends FormInputElement<boolean> {

    public static readonly styles = Styles;

    @property({attribute: "label-check"})
    private labelCheck: string;
    @property({attribute: "label-uncheck"})
    private labelUncheck: string;

    public constructor(private clickTracking: ClickTracking = resolve(ClickTracking)) {
        super(false);
    }

    public render(): TemplateResult {
        return html`<a @click=${this.toggle}>${this.getLabel()}</a>`;
    }

    private toggle(event: Event): void {
        event.stopPropagation();
        this.clickTracking.handleTextlinkInteract(event, this.getLabel());

        this.updateValue(!this.value);
    }

    private getLabel(): string {
        return this.value
            ? this.labelUncheck
            : this.labelCheck;
    }

    protected preset(): boolean {
        return false;
    }

    public focusInput(): void {
        noop();
    }
}